module.exports = __webpack_public_path__ + "img/qywx.0dbc0093.png";